import React, { FC } from 'react';
import { Timeline, Tooltip } from 'antd';
import { Icon, faTimeline } from '@/ui/components';
import { dateConverter } from '@/utils/helpers';
import { AuditActionType, AuditLog, AuditLogEvent } from '@/types';

const ACTION_COLOR: Record<string, string> = {
  [AuditActionType.Create]: 'green',
  [AuditActionType.Update]: 'orange',
  [AuditActionType.Delete]: 'red',
  [AuditActionType.UnDelete]: 'purple',
};

interface AuditLogTimelineTooltipProps {
  auditLogs?: AuditLog[];
}

export const AuditLogTimelineTooltip: FC<AuditLogTimelineTooltipProps> = ({
  auditLogs,
}) => {
  if (!auditLogs?.length) return null;

  return (
    <Tooltip
      classNames={{ root: 'timeline-tooltip' }}
      styles={{
        root: { minWidth: 400 },
        body: { paddingTop: 30, paddingRight: 10 },
      }}
      color="#fff"
      zIndex={1000}
      placement="left"
      title={
        <Timeline
          items={auditLogs.map((log) => {
            const eventType =
              AuditLogEvent[
                log.eventType as unknown as keyof typeof AuditLogEvent
              ];
            return {
              color: ACTION_COLOR[log.actionType] || 'gray',
              children: (
                <>
                  {log.userName}{' '}
                  {log.actionType[0].toLocaleLowerCase() +
                    log.actionType.slice(1)}{' '}
                  <b>{eventType}</b> at {dateConverter(log.createAt, 'lll')}
                </>
              ),
            };
          })}
        />
      }
    >
      <div className="cursor-pointer" data-testid="audit-log-timeline">
        <Icon icon={faTimeline} className="hoverable-icon" />
      </div>
    </Tooltip>
  );
};
